import ExcessSetCheckSettings from './ExcessSetCheckSettings.graphql';
import ExcessChangeCabinetStatus from './ExcessChangeCabinetStatus.graphql';

export const mutations = {
  ExcessSetCheckSettings,
  ExcessChangeCabinetStatus,
};
